import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType } from "__generated__/graphql";

export const SchemaRegistryLoaders: Partial<Record<CalculationMethodType, () => Promise<RegistryItem>>> = {
	[CalculationMethodType.Lumpsum]: () => import("./lumpsum.schema").then(r => r.LumpsumSchema),
	[CalculationMethodType.CargoQuantity]: () => import("./cargoQuantity.schema").then(r => r.CargoQuantitySchema),
	[CalculationMethodType.PercentageOnAgreements]: () => import("./percentageOnAgreements.schema").then(r => r.PercentageOnAgreementsSchema),
	[CalculationMethodType.CoveredByFreightPrice]: () => import("./coveredByFreightPrice.schema").then(r => r.CoveredByFreightPriceSchema),
	[CalculationMethodType.Demurrage]: () => import("./demurrage.schema").then(r => r.DemurrageSchema),
	[CalculationMethodType.DemurrageCalculation]: () => import("./demurrageCalculation.schema").then(r => r.DemurrageCalculationSchema),
	[CalculationMethodType.GasoilConsumption]: () => import("./gasoilConsumption.schema").then(r => r.GasoilConsumptionSchema),
	[CalculationMethodType.Manual]: () => import("./manual.schema").then(r => r.ManualSchema),
	[CalculationMethodType.QuantityUnit]: () => import("./quantityUnit.schema").then(r => r.QuantityUnitSchema),
	[CalculationMethodType.ReferenceRate]: () => import("./referenceRate.schema").then(r => r.ReferenceRateSchema),
	[CalculationMethodType.Staffel]: () => import("./staffel.schema").then(r => r.StaffelSchema),
	[CalculationMethodType.Tiered]: () => import("./tiered.schema").then(r => r.TieredSchema),
	[CalculationMethodType.TimeUnit]: () => import("./timeUnit.schema").then(r => r.TimeUnitSchema),
};

export async function loadSchema(type?: CalculationMethodType) {
	if (type == null) {
		return null;
	}

	const registryItem = await SchemaRegistryLoaders[type]?.();
	return registryItem?.[type];
}
